/* =============================================================
 * sr-portfolio-button.js
 * Botón "Añadir a cartera" reutilizable FUERA del informe
 * (p. ej. página de seguimiento de tesis). Autocontenido: NO
 * depende de product-informe.js. Reutiliza los globals que
 * expone el snippet `sr-portfolio-context`:
 *   window.SR_CUSTOMER_ID
 *   window.SR_PORTFOLIO_WEBHOOKS.upsert_position
 *   window.SR_PORTFOLIO_SNAPSHOT
 *
 * Contrato DOM (idéntico al informe, así comparten estilos/clases):
 *   .favorito-wrapper[data-handle | data-ticker | data-product-gid |
 *     data-in-portfolio | data-customer-logged-in | data-customer-id |
 *     data-label-add | data-label-added | data-mi-cartera-url]
 *     > .btn-favorito > .favorito-icon + .favorito-text
 *
 * Comportamiento (mismo que product-informe.js):
 *   - Anónimo            → /pages/onboarding?from=favorito&add={handle}
 *   - Logueado, ya está  → data-mi-cartera-url (default /pages/mi-cartera)
 *   - Logueado, nuevo    → upsert_position (modo watch) con snapshot completo
 *     (Make reconstruye custom.portfolio desde `positions`; sin snapshot
 *      completo un upsert borraría posiciones → si falta, caemos a onboarding).
 * ============================================================= */
(function () {
  'use strict';
  if (window.__srPortfolioButtonInit) return;
  window.__srPortfolioButtonInit = true;

  function setPortfolioState(added) {
    document.querySelectorAll('.favorito-wrapper').forEach(function (w) {
      w.dataset.inPortfolio = added ? 'true' : 'false';
      var icon = w.querySelector('.favorito-icon');
      var text = w.querySelector('.favorito-text');
      var btn = w.querySelector('.btn-favorito');
      if (icon) icon.textContent = added ? '✓' : '+';
      if (text) text.textContent = added ? (w.dataset.labelAdded || 'En cartera') : (w.dataset.labelAdd || 'Añadir a cartera');
      if (btn) btn.setAttribute('aria-label', added ? 'Ya en tu cartera' : 'Añadir a cartera');
    });
  }

  function showError(message) {
    var wrapper = document.querySelector('.favorito-wrapper');
    if (!wrapper) return;
    var existing = wrapper.querySelector('.favorito-error');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'favorito-error';
    el.textContent = message;
    wrapper.appendChild(el);
    setTimeout(function () { if (el.parentNode) el.remove(); }, 4000);
  }

  async function toggle(wrapper) {
    if (!wrapper) return;

    var handle = wrapper.dataset.handle || '';
    var isLoggedIn = wrapper.dataset.customerLoggedIn === 'true';

    // 1) Anónimo → onboarding con el ticker precargado.
    if (!isLoggedIn) {
      window.location.href = '/pages/onboarding?from=favorito&add=' + encodeURIComponent(handle);
      return;
    }

    var miCarteraUrl = wrapper.dataset.miCarteraUrl || '/pages/mi-cartera';

    // 2) Ya en cartera → a Mi cartera, sin reescribir.
    if (wrapper.dataset.inPortfolio === 'true') {
      window.location.href = miCarteraUrl;
      return;
    }

    var ticker = wrapper.dataset.ticker || '';
    var productGid = wrapper.dataset.productGid || '';
    var customerId = (window.SR_CUSTOMER_ID || wrapper.dataset.customerId || '').toString().replace(/[^0-9]/g, '');
    var webhooks = window.SR_PORTFOLIO_WEBHOOKS || {};
    var webhook = (webhooks.upsert_position || '').trim();
    var snapshot = Array.isArray(window.SR_PORTFOLIO_SNAPSHOT) ? window.SR_PORTFOLIO_SNAPSHOT.slice() : null;

    // 3) Sin contexto seguro (snapshot/webhook/customer) NO escribimos directo —
    //    un upsert parcial podría borrar la cartera. Caemos al onboarding.
    if (!webhook || !customerId || snapshot === null) {
      window.location.href = '/pages/onboarding?from=favorito&add=' + encodeURIComponent(handle);
      return;
    }

    if (!snapshot.some(function (p) { return (p.ticker || '').toUpperCase() === ticker.toUpperCase(); })) {
      snapshot.push({ ticker: ticker, product_gid: productGid, handle: handle });
    }

    // Optimistic UI
    setPortfolioState(true);
    document.querySelectorAll('.favorito-wrapper .btn-favorito').forEach(function (b) {
      b.disabled = true;
      b.classList.add('btn-favorito--loading');
    });

    try {
      var response = await fetch(webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'upsert_position',
          customer_id: customerId,
          ticker: ticker,
          product_gid: productGid,
          transactions: [],
          net_shares: 0,
          avg_price: 0,
          invested: 0,
          mode: 'watch',
          positions: snapshot
        })
      });
      if (!response.ok) throw new Error('HTTP error: ' + response.status);
      window.SR_PORTFOLIO_SNAPSHOT = snapshot;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'add_to_portfolio', source: 'seguimiento', ticker: ticker, mode: 'watch' });
    } catch (error) {
      console.error('Error al añadir a la cartera:', error);
      setPortfolioState(false);
      showError('No se pudo añadir a tu cartera. Inténtalo de nuevo.');
    } finally {
      document.querySelectorAll('.favorito-wrapper .btn-favorito').forEach(function (b) {
        b.disabled = false;
        b.classList.remove('btn-favorito--loading');
      });
    }
  }

  function init() {
    document.querySelectorAll('.favorito-wrapper').forEach(function (wrapper) {
      var btn = wrapper.querySelector('.btn-favorito');
      if (btn && !btn._favInitialized) {
        btn._favInitialized = true;
        btn.addEventListener('click', function () { toggle(wrapper); });
      }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
